import React from 'react'
import Layout from '../components/layout'
import BackgroundVideo from '../components/backgroundVideo'
import styles from './styles.module.css'
import SEO from '../components/seo'

export default () => {
    return (
        <Layout>
            <SEO 
                title='about' 
                description="Who's sappzo?"
                pathname='about/'
            />
            <BackgroundVideo initClip='TuktukRed'/>
            <section className={styles.section}>
                <p className={styles.aboutNote} id='aboutNote'>
                    Hi! I'm <a href='https://sappzo.com/'>sappzo</a>, a newbie solo indie dev and this is my first game! It'll be available on Microsoft Windows, Android, iOS, and Macintosh operating systems Q3 this year!  
                    {/* Check out more of my <a href='https://sappzo.com/games/#games'>games!</a>  */}
                </p> 
            </section>
        </Layout>
    )
}  